import React from "react";
import "./index.css";
import CapriFooter from "./../../assets/capri-logo-footer.webp";
function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-column">
          <h4>Company</h4>
          <ul>
            <li>
              <a href="/about-us">About Us</a>
            </li>
            <li>
              <a href="/">Our Strategy</a>
            </li>
            <li>
              <a href="/teams">Teams</a>
            </li>
            <li>
              <a href="/portfolio">Our Portfolio</a>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Learn</h4>
          <ul>
            <li>
              <a href="/news-media">News and Media</a>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Support</h4>
          <ul>
            <li>
              <a href="/contact">Get in Touch</a>
            </li>
            <li>
              <a href="#terms">Terms and Conditions</a>
            </li>
            <li>
              <a href="#privacy">Privacy Policy</a>
            </li>
            <li>
              <a href="#sitemap">Sitemap</a>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Contact</h4>
          <ul>
            <li>
              <a href="tel:+91224088100">📞 +91-22-40888100</a>
            </li>
            <li>
              <a href="mailto:support@caprixponentia.in">
                📧 support@caprixponentia.in
              </a>
            </li>
            <li>
              <p>
                📍 1B, 1st Floor, Court Chambers,
                <br />
                35, Sir Vithaldas Thackersey Marg,
                <br />
                New Marine Lines, Mumbai - 400020.
              </p>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-logo">
          <img src={CapriFooter} alt="Capri Xponentia Managers LLP Logo" />
        </div>
        <div className="footer-links">
          <a href="#fraud-alert">Fraud Alert</a> |{" "}
          <a href="#sitemap">Sitemap</a>
        </div>
        <p>&copy; 2024 Capri Xponentia Managers LLP. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
